import { render, staticRenderFns } from "./CourseLesson.vue?vue&type=template&id=3c5b4e9c&scoped=true"
import script from "./CourseLesson.vue?vue&type=script&lang=js"
export * from "./CourseLesson.vue?vue&type=script&lang=js"
import style0 from "./CourseLesson.vue?vue&type=style&index=0&id=3c5b4e9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b4e9c",
  null
  
)

export default component.exports